export const projectRequestPagePath = '/partner/project-request';